export default function useChat() {
  const resolveAvatarBadgeVariant = status => {
    if (status === 'online') return 'success'
    if (status === 'busy') return 'danger'
    if (status === 'away') return 'warning'
    // Çevrimdışı (ve bilinmeyen durum) kırmızı gösterilir
    return 'danger'
  }

  return {
    resolveAvatarBadgeVariant,
  }
}
